import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star, User } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const Hero = () => {
  return <section className="relative pt-10 pb-12 lg:pt-14 lg:pb-20 overflow-hidden" data-id="element-147">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] bg-radial-fuchsia opacity-50 pointer-events-none" data-id="element-148" />

      <div className="container mx-auto px-6 max-w-4xl relative z-10 text-center" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-150">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight text-text-main mb-8" data-id="element-151">
            Sistema para{' '}
            <span className="text-fuchsia italic font-normal" data-id="element-152">
              cosmetólogas
            </span>{' '}
            que quieren agenda llena y{' '}
            <span className="text-fuchsia italic font-normal" data-id="element-153">
              precios premium
            </span>{' '}
            en 7 días
          </h1>
        </motion.div>

        {/* Product Mockup — in between title and subtitle */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.9,
        delay: 0.15
      }} className="relative flex items-center justify-center my-8 md:my-12" data-id="element-154">
          <div className="absolute inset-0 bg-radial-glow opacity-80" data-id="element-155" />
          <motion.img animate={{
          y: [-8, 8, -8]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} src="https://cdn.magicpatterns.com/uploads/pCckx173jKu4BnzAAN22u6/Untitled_design_(1).png" alt="Glow Skin PRO KIT" className="relative z-10 w-full max-w-md md:max-w-lg drop-shadow-2xl" data-id="element-156" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-157">
          <p className="text-base md:text-xl text-text-muted mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-158">
            Conviértete en una profesional de la estética y haz crecer tu
            negocio beauty con el sistema más completo y práctico.
          </p>

          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-10" data-id="element-159">
            {['Acceso inmediato', 'Bonos exclusivos', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-center gap-2 text-text-main font-medium text-sm" data-id="element-160">
                  <CheckCircle2 className="w-4 h-4 text-gold" data-id="element-161" />
                  {item}
                </li>)}
          </ul>

          <div className="flex flex-col items-center gap-6" data-id="element-162">
            <CTAButton data-id="element-163" />

            <div className="flex items-center gap-3" data-id="element-164">
              <div className="flex -space-x-2" data-id="element-165">
                {[{
                bg: 'bg-pink-light',
                color: 'text-fuchsia'
              }, {
                bg: 'bg-gold/30',
                color: 'text-gold-dark'
              }, {
                bg: 'bg-fuchsia/20',
                color: 'text-fuchsia'
              }, {
                bg: 'bg-pink-medium',
                color: 'text-fuchsia-dark'
              }].map((avatar, i) => <div key={i} className={`w-8 h-8 rounded-full border-2 border-base flex items-center justify-center ${avatar.bg}`} data-id="element-166">
                    <User className={`w-4 h-4 ${avatar.color}`} data-id="element-167" />
                  </div>)}
                <div className="w-8 h-8 rounded-full border-2 border-base bg-gradient-fuchsia flex items-center justify-center text-[10px] font-bold text-white" data-id="element-168">
                  +12k
                </div>
              </div>
              <div className="flex flex-col items-start" data-id="element-169">
                <div className="flex" data-id="element-170">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-gold text-gold" data-id="element-171" />)}
                </div>
                <span className="text-xs font-medium text-text-muted" data-id="element-172">
                  +12,400 mujeres transformadas
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};